import { useEffect,useState,useRef } from 'react';
import { io } from 'socket.io-client';
import { Link, Route, Routes, useSearchParams, useNavigate, useLocation, Outlet } from 'react-router-dom'
import localForage from "localforage";
import 'react-toastify/dist/ReactToastify.min.css';
import './App.css';
import { v4 as uuid } from 'uuid';
import { Home } from './pages/Home'
import { Songs } from './pages/Songs'
import { Yt } from './pages/Yt'
import { Artists } from './pages/Artists'
import { Favourites } from './pages/Favourites'
import { Rec } from './pages/Rec'
import { New } from './pages/New'
import { Footer } from './pages/Footer'
import { TableNo } from './pages/TableNo'
import { Hot } from './pages/Hot'
import { List } from './pages/List'
import { Overview } from './pages/Overview'
import strings from './strings.js'
import { NoRoomError } from './pages/NoRoomError'
import { Root    } from './pages/Root'
import { Admin } from './pages/Admin'
import { ToastContainer } from 'react-toastify';
import axios from 'axios';
import bgHome3 from './img2026/bgimg-home-3.jpg';
import bgListPage from './img2026/bgimg-list-page.jpg';
import bgBallsTab from './img2026/bgimg-balls-tab.jpg';

const socket = io('https://starboxkod.com/', {path: "/socket.io", autoConnect:false, reconnection: true, reconnectionDelay: 500, reconnectionDelayMax: 1500,  maxReconnectionAttempts:Infinity})

if (JSON.parse(localStorage.getItem("sn")) == null)
    localStorage.setItem("sn", JSON.stringify(uuid()));

function SendMessage(message) {
    if (socket.connected){
        socket.emit("send-message", message)
    }
    else {
        return;
    }
}

function _base64ToArrayBuffer(base64) {
    var binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
}

socket.on("connect", () => {
    localForage.getItem("room").then(function(value) {
        
        //new one line 20231216
        localStorage.setItem("room", JSON.stringify(value));

        socket.emit("join-room", value);
        socket.emit("send-message", '[{"type":"PING"}]');
        socket.emit("send-message", '[{"type":"PING"}]');
        socket.emit("send-message", '[{"type":"TOP_REQ"}]');
        socket.emit("send-message", '[{"type":"BLACK_REQ"}]');
        //socket.emit("send-esp", "0");
    });
})

const App = () => {
    const location = useLocation(); // <--- Add this line
    const [cookieFavs, setCookieFavsActual] = useState([]); 
    async function setCookieFavs(value) {
        setCookieFavsActual(value);
       //localForage.setItem("favs", value);
        if (window.location.hostname === 'localhost') {
            console.log("Skipping updateFav on localhost");
            return;
        }
        await axios.post('https://starboxkod.com/api/updateFav', {
            database: JSON.stringify(value)
        });
    }
    useEffect(() => {
        const sendRequest = async () => {
          try {
            try { 
                const response = JSON.parse((await axios.get('https://starboxkod.com/api/getFav')).data.database);
                setCookieFavs(response);
            }
            catch {}
            localForage.getItem("favs").then(async function(value) {
                if (value !== null) {
                    console.log("needToMigrate");
                    if (window.location.hostname === 'localhost') {
                        console.log("Skipping updateFav on localhost");
                        return;
                    }
                    await axios.post('https://starboxkod.com/api/updateFav', {
                        database: JSON.stringify(value)
                    });
                    const verify = JSON.parse((await axios.get('https://starboxkod.com/api/getFav')).data.database);
                    if (JSON.stringify(verify) === JSON.stringify(value)) {
                        console.log("successMigration");
                        console.log("verify", verify);
                        console.log("value", value);
                        console.log("Attempting to remove favs from localForage");
                        await localForage.removeItem("favs");  // Explicitly await here
                        console.log("favs removed from localForage");
                        setCookieFavs(verify);
                    } else {
                        console.log("failedMigration");
                        console.log("verify", verify);
                        console.log("value", value);
                        setCookieFavs(value);
                    }
                }
            });
          } catch (error) {
            console.error('Error fetching data:', error);
          }
        };
        sendRequest();
      }, []);

    const [downloadingInProgress, setDownloadingInProgress] = useState(-1);

    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    let timerId;

    function setLang(value) {
        setLangActual(value);
        localStorage.setItem("lang", JSON.stringify(value));
        localForage.setItem("lang", value);
    }

    const [serverOnline, setServerOnline] = useState("no");
    const serverOnlineRef = useRef(serverOnline);

    // Update the ref whenever serverOnline changes
    useEffect(() => {
        serverOnlineRef.current = serverOnline;
    }, [serverOnline]);


    // 260918newSkin
    const [skin, setSkin] = useState(0);

    useEffect(() => {
        // 1. Dynamically update the data-skin attribute on document body
        document.body.setAttribute('data-skin', skin);

        // 2. Dynamically update the browser top bar color
        const themeColor = String(skin) === '1' ? '#e03637' : '#3751fe';
        const metaTheme = document.querySelector('meta[name="theme-color"]');
        
        if (metaTheme) {
            metaTheme.setAttribute('content', themeColor);
        }
    }, [skin]);


useEffect(() => {
    if (skin === 1) {
        let bgImage = bgListPage; // Default

        if (location.pathname === '/tableNo') {
            bgImage = bgHome3;
        } else if (location.pathname === '/home') {
            bgImage = bgBallsTab;
        }

        document.body.style.backgroundImage = `url(${bgImage})`;
    }
}, [location.pathname, skin]);
    //260918newSkin

    const [tableNo, setTableNo] = useState(1);
    const [lang, setLangActual] = useState(JSON.parse(localStorage.getItem("lang")));
    const [stateVer, setStateVer] = useState("");
    const [statePlaybackUserId, setStatePlaybackUserId] = useState("55");

    const [stateTables, setStateTables] = useState({"t1":{"playlist":[],"quota":2,"locked":true}});
    const [statePlaylist, setStatePlaylist] = useState("");


    const [statePlaylistYT, setStatePlaylistYT] = useState('{}');
    
    
    const [stateRec, setStateRec] = useState("");
    const [statePlaybackSong, setStatePlaybackSong] = useState("");
    const [statePlaybackYT, setStatePlaybackYT] = useState("");
    const [stateYouTube, setStateYouTube] = useState(false);

    const [stateQrLock, setStateQrLock] = useState(false);

    const [statePaused, setStatePaused] = useState(false);
    const [stateDuration, setStateDuration] = useState(-1);

    const [statePlaybackUserIdAndSong, setStatePlaybackUserIdAndSong] = useState("");

    const [stateNextTable, setStateNextTable] = useState();
    const [stateNextSong, setStateNextSong] = useState();
    const [stateNextYtname, setStateNextYtname] = useState();


    const [selectedSinger, setSelectedSinger] = useState({});



    const [micEnabled, setMicEnabled] = useState(false);

    useEffect(() => {
        // This effect runs whenever statePlaybackUserIdAndSong changes
        setHasReplayed(false); // Reset hasReplayed to false when statePlaybackUserIdAndSong changes
        if (micEnabled && stateVer === "dating") {
            socket.emit("m1");
        }
    }, [statePlaybackUserIdAndSong]);


    function handleStatePlaybackUserIdAndSongChange(value) {
        if (value !== statePlaybackUserIdAndSong) {
            setStatePlaybackUserIdAndSong(value);
        }
    }

    const [hasReplayed, setHasReplayed] = useState(false);

    useEffect(() => {
        let durationIntervalId;
    
        if (!statePaused) {
            durationIntervalId = setInterval(() => {
            setStateDuration(prevDuration => prevDuration + 1);
          }, 1000);
        }
    
        return () => {
          clearInterval(durationIntervalId);
        };
      }, [statePaused, stateDuration]);


    useEffect(() => {


        //20250510
        //localStorage.removeItem("serverHereReal");
        localStorage.removeItem("black");
        localStorage.setItem("state", JSON.stringify({}));
        localStorage.setItem("state", JSON.stringify({}));
        localStorage.setItem("serverHere", JSON.stringify(false));
        //사용자가 QR 코드를 스캔했는지 확인합니다
        if (searchParams.get("room") === null && searchParams.get("v") === null) {
            //아니, 사용자가 이전에 로그인했는지 확인
            localForage.getItem("lastLogin").then(function(value) {
                if ((Date.now() - value) > 36000000) {
                    //아니, 이제 그만 (열시)
                    navigate("/NoRoomError", {replace:true});
                }
                else {
                    //네, 세션 복원
                            localForage.getItem("room").then(function(value) {
                
                                if(value == "602502172700" || value == "602305135291")
                                {
                                    setSkin(1);   
                                }
                            })

                    navigate("/", {replace:true})
                    socket.connect();
                    localForage.setItem("lastLogin", Date.now());
                }
            });
        } else if (searchParams.get("v") !== null) {
            //axios check if "v" == a valid string
                //if valid, join
                //localForage.getItem("table")
                localForage.setItem("table", 147).then(function(value) {
                    socket.connect();
                    localForage.setItem("lastLogin", Date.now());
                    navigate("/", {replace:true});
                })
        } else {
            //네, QR 코드가 스캔되었습니다
            localForage.setItem("room", searchParams.get("room")).then(function(value) {
                if(value == "602502172700" || value == "602305135291")
                {
                    setSkin(1);   
                }
                //new one line 20231216
                localStorage.setItem("room", JSON.stringify(value));

                if(searchParams.get("table") === null) {
                    localForage.removeItem("table").then(function() {
                        socket.connect();
                        localForage.setItem("lastLogin", Date.now());
                        navigate("/", {replace:true});
                    })
                } else {
                    localForage.setItem("table", parseInt(searchParams.get("table"))).then(function(value) {
                        socket.connect();
                        localForage.setItem("lastLogin", Date.now());
                        navigate("/", {replace:true});
                    })
                }
            })
        }

    
    /*
    function handleOnBeforeUnload(event) {
        event.preventDefault();
        return (event.returnValue = '');
    }

    window.addEventListener('beforeunload', handleOnBeforeUnload, {capture:true})

*/
    
    socket.on("receive-file", data => {
        const buffer = _base64ToArrayBuffer(data.buffer);
        const blob=new Blob([buffer],{type:'audio/mpeg'})
        const a = document.createElement('a');
        document.body.appendChild(a);
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = data.filename;
        a.click();
        setTimeout(() => {
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
            setDownloadingInProgress(-1);
        }, 0)
    })



    socket.on("disconnect", () => {
        if (timerId) clearTimeout(timerId);
        navigate("/", {replace:true})
        //20250510try to disable lol
        setServerOnline("no")
        //20250510
        //localStorage.removeItem("serverHereReal");
    });

/*
    socket.on("receive-esp", message => {
        switch (message)
        {
            case "pong":
                //extendTimer
                break;
        }
       try {
            switch(message.type)
            {
                case "0": //0 is heartbeat from ESP
                    //startTimer();
                    break;
            }
        }
        catch {
            return;
        } 
    });
*/


    socket.on("receive-message", message => {
        try {
            const obj = JSON.parse(message);
            switch(obj[0].type)
            {
                case "state":
                    startTimer();
                    localStorage.setItem("state", JSON.stringify(obj[0]));
                    localStorage.setItem("serverHere", JSON.stringify(true));

                    setStatePlaybackUserId(obj[0].playbackUserId);
                    setStateTables(obj[0].tables);

                    try {
                        setStatePlaybackYT(JSON.parse(localStorage.getItem("state")).playbackYtname.toString());
                    }
                    catch {}
                    try {
                        setStatePlaybackSong(JSON.parse(localStorage.getItem("state")).playbackSong.toString());
                        handleStatePlaybackUserIdAndSongChange(JSON.parse(localStorage.getItem("state")).playbackSong.toString() + obj[0].playbackUserId);
                    }
                    catch {}
                    try {
                        setStateYouTube(JSON.parse(localStorage.getItem("state")).youtube);
                    }catch {}
                    try {
                        setStateQrLock(JSON.parse(localStorage.getItem("state")).qrLock);
                    }catch {}
                    try {
                        setStatePaused(JSON.parse(localStorage.getItem("state")).paused);
                    }catch {
                        setStatePaused(true);
                    }
                    try {
                        setStateDuration(JSON.parse(localStorage.getItem("state")).duration);
                    }catch {
                        setStateDuration(-1);
                    }

                    
                    try {setStateNextTable(JSON.parse(localStorage.getItem("state")).nextTable);} catch {}

                    try {setStateNextSong(JSON.parse(localStorage.getItem("state")).nextSong);} catch {}

                    try {setStateNextYtname(JSON.parse(localStorage.getItem("state")).nextYtname);} catch {}
                    //20250510
                    //if (JSON.parse(localStorage.getItem("serverHereReal")) == null)
                    console.log("serverOnline is" + serverOnlineRef.current);
                    if (serverOnlineRef.current === "no")
                    {
                        setServerOnline("yes")
                        
                        //20250510
                        //localStorage.setItem("serverHereReal", JSON.stringify("blackpink"));

                        switch(obj[0].ver)
                        {
                            case "wangluo":
                                localForage.setItem("table", 1).then(
                                    console.log("itzy"),
                                    setStateVer("wangluo"),
                                    setTableNo(1),
                                    navigate("/home", {replace:true}),
                                    setStatePlaylist(JSON.parse(localStorage.getItem("state")).tables["t1"]["playlist"].map(f=> f.songcode).toString()),
                                    
                                    setStatePlaylistYT(JSON.parse(localStorage.getItem("state")).tables["t1"]["playlist"].map(f=> f.ytname)),
                                )
                                break;
                            case "danji": case "dating":
                                setStateVer("dating");
                                localForage.getItem("table").then(function(value) {
                                    console.log(value)
                                    if (value === null) {
                                        console.log("ASDASD")
                                        //로그인하지 않음
                                        navigate("/tableNo", {replace:true});
                                    }
                                    else {
                                        //로그인됨
                                        if (value === 147) {
                                            setTableNo(147);
                                            SendMessage('[{"type":"MSG_REQ"}]');
                                            navigate("/admin", {replace:true});
                                        } else { //existing table was locked or if the qr is hidden
                                            if (obj[0].tables["t" + value]["locked"] || obj[0].qrLock) //or if qrHide
                                            {
                                                navigate("/tableNo", {replace:true})
                                            }
                                            else
                                            { 
                                                setStatePlaylist(JSON.parse(localStorage.getItem("state")).tables["t" + parseInt(value)]["playlist"].map(f=> f.songcode).toString());
                                                setStateRec(JSON.parse(localStorage.getItem("state")).tables["t" + parseInt(value)]["rec"].map(f=> f.songcode).toString());
                                                setTableNo(value);
                                                navigate("/home", {replace:true});
                                                try {
                                                    
                                                    setStatePlaylistYT(JSON.parse(localStorage.getItem("state")).tables["t" + parseInt(value)]["playlist"].map(f=> f.ytname));
                                                }
                                                catch {}
                                            }
                                        }
                                    }
                                });
                                break;
                            case "danji2":
                                localForage.setItem("table", 1).then(
                                    console.log("yeji"),
                                    setStateVer("danji"),
                                    setTableNo(1),
                                    setStatePlaylist(JSON.parse(localStorage.getItem("state")).tables["t1"]["playlist"].map(f=> f.songcode).toString()),
                                    setStateRec(JSON.parse(localStorage.getItem("state")).tables["t1"]["rec"].map(f=> f.songcode).toString()),
                                    navigate("/home", {replace:true}),
                                ).then(() => {  
                                    try {
                                       
                                        setStatePlaylistYT(JSON.parse(localStorage.getItem("state")).tables["t1"]["playlist"].map(f=> f.ytname));
                                    }
                                    catch {}
                                })
                                break;
                        }
                    }
                    else{
                        localForage.getItem("table").then(function(value) {
                            console.log(value)
                            if (value == null) return;
                            if (value !== 147) {
                                if (JSON.parse(localStorage.getItem("state")).tables["t" + parseInt(value)]["locked"] === false) {
                                    console.log("wonyoung")
                                    setStatePlaylist(JSON.parse(localStorage.getItem("state")).tables["t" + parseInt(value)]["playlist"].map(f=> f.songcode).toString());
                                    try {
                                       
                                        setStatePlaylistYT(JSON.parse(localStorage.getItem("state")).tables["t" + parseInt(value)]["playlist"].map(f=> f.ytname));
                                    }
                                    catch {}
                                    switch(obj[0].ver)
                                    {
                                        case "danji": case "dating":
                                            setStateRec(JSON.parse(localStorage.getItem("state")).tables["t" + parseInt(value)]["rec"].map(f=> f.songcode).toString());
                                            break;
                                        case "wangluo":
                                            break;
                                        case "danji2":
                                            setStateRec(JSON.parse(localStorage.getItem("state")).tables["t" + parseInt(value)]["rec"].map(f=> f.songcode).toString());
                                            break;
                                    }
                                }
                                else {
                                    navigate("/NoRoomError")
                                }
                            }
                        })
                    }
                    break;
                case "top":
                    localStorage.setItem("top", JSON.stringify(obj[0]));
                    break;
                case "black":
                    localStorage.setItem("black", JSON.stringify(obj[0]));
                    break;
                case "MIC_ENABLED":
                    setMicEnabled(true);
                    break;
                case "msg":
                    localStorage.setItem("msg", JSON.stringify(obj[0].msglist));
                    break;
                case "heartbeat":
                    startTimer();
                    break;
            }
        }
        catch {
            return;
        }
    })

    }, []);

    

    const startTimer = () => {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeout(logOutUser, 180000);
    }

    const logOutUser = () => { 
        if(socket.connected) {
            localStorage.setItem("serverHere", JSON.stringify(false));
            navigate("/NoRoomError", {replace:true});
        } else {
        }
    };

    

    

    return (
        <>
        <div className="app">
            <ToastContainer closeButton={false}/>
            <Routes>
                <Route path="/tableNo" element={<TableNo skin={skin} stateVer={stateVer} setTableNo={setTableNo} setLang={setLang} lang={lang} setStatePlaylist={setStatePlaylist} setStatePlaylistYT={setStatePlaylistYT} setStateRec={setStateRec} setStatePlaybackSong={setStatePlaybackSong} setStateYouTube={setStateYouTube} stateQrLock={stateQrLock}/>} />
                <Route path="/home" element={<Footer hasReplayed={hasReplayed} setHasReplayed={setHasReplayed} stateVer={stateVer} tableNo={tableNo} lang={lang} statePlaybackUserId={statePlaybackUserId} stateDuration={stateDuration} micEnabled={micEnabled}/>}>
                    <Route index element={<Home skin={skin} stateDuration={stateDuration} stateVer={stateVer} setLang={setLang} lang={lang} statePlaylist={statePlaylist} stateYouTube={stateYouTube}/> } />
                    

                    <Route path="songs" element={<Songs  skin={skin} cookieFavs={cookieFavs} setCookieFavs={setCookieFavs} selectedSinger={selectedSinger} setSelectedSinger={setSelectedSinger} stateVer={stateVer} lang={lang} selectingSinger={false} selectingYesNo={false} tableNo={tableNo}/>} />
                    <Route path="songs/select" element={<Songs skin={skin} cookieFavs={cookieFavs} setCookieFavs={setCookieFavs}  selectedSinger={selectedSinger} setSelectedSinger={setSelectedSinger} stateVer={stateVer} lang={lang} selectingSinger={false} selectingYesNo={true} tableNo={tableNo}/>} />
                    
                    <Route path="songs/singer" element={<Songs  skin={skin}  cookieFavs={cookieFavs} setCookieFavs={setCookieFavs} selectedSinger={selectedSinger} setSelectedSinger={setSelectedSinger} stateVer={stateVer} lang={lang} selectingSinger={true} selectingYesNo={false} tableNo={tableNo}/>} />
                    <Route path="songs/singer/select" element={<Songs  skin={skin} cookieFavs={cookieFavs} setCookieFavs={setCookieFavs}  selectedSinger={selectedSinger} setSelectedSinger={setSelectedSinger} stateVer={stateVer} lang={lang} selectingSinger={true} selectingYesNo={true} tableNo={tableNo}/>} />

                    <Route path="artists" element={<Artists  cookieFavs={cookieFavs} setCookieFavs={setCookieFavs} selectedSinger={selectedSinger} setSelectedSinger={setSelectedSinger} stateVer={stateVer} lang={lang} selectingSinger={false} selectingYesNo={false} tableNo={tableNo}/>} />
                    <Route path="artists/singer" element={<Artists cookieFavs={cookieFavs} setCookieFavs={setCookieFavs} selectedSinger={selectedSinger} setSelectedSinger={setSelectedSinger}  stateVer={stateVer} lang={lang} selectingSinger={true} selectingYesNo={false} tableNo={tableNo}/>} />
                    <Route path="artists/singer/select" element={<Artists cookieFavs={cookieFavs} setCookieFavs={setCookieFavs} selectedSinger={selectedSinger} setSelectedSinger={setSelectedSinger}  stateVer={stateVer} lang={lang} selectingSinger={true} selectingYesNo={true} tableNo={tableNo}/>} />
                    <Route path="hot" element={<Hot  cookieFavs={cookieFavs} setCookieFavs={setCookieFavs} setSelectedSinger={setSelectedSinger} stateVer={stateVer} lang={lang} selectingYesNo={false} tableNo={tableNo}/>} />
                    <Route path="hot/select" element={<Hot cookieFavs={cookieFavs} setCookieFavs={setCookieFavs} setSelectedSinger={setSelectedSinger} stateVer={stateVer} lang={lang} selectingYesNo={true} tableNo={tableNo}/>} />
                    <Route path="new" element={<New  cookieFavs={cookieFavs} setCookieFavs={setCookieFavs} setSelectedSinger={setSelectedSinger}  stateVer={stateVer} lang={lang} selectingYesNo={false} tableNo={tableNo} />} />
                    <Route path="new/select" element={<New cookieFavs={cookieFavs} setCookieFavs={setCookieFavs}  setSelectedSinger={setSelectedSinger}  stateVer={stateVer} lang={lang} selectingYesNo={true} tableNo={tableNo}/>} />
                    <Route path="list" element={<List  setSelectedSinger={setSelectedSinger} stateVer={stateVer} lang={lang} statePlaylist={statePlaylist} statePlaylistYT={statePlaylistYT} tableNo={tableNo} />} />
                    <Route path="rec" element={<Rec  cookieFavs={cookieFavs} setCookieFavs={setCookieFavs} setSelectedSinger={setSelectedSinger} stateVer={stateVer} lang={lang} stateRec={stateRec} tableNo={tableNo} downloadingInProgress={downloadingInProgress} setDownloadingInProgress={setDownloadingInProgress} />} />
                    <Route path="fav" element={<Favourites  cookieFavs={cookieFavs} setCookieFavs={setCookieFavs} setSelectedSinger={setSelectedSinger}  stateVer={stateVer} lang={lang} selectingYesNo={false} tableNo={tableNo} />} />
                    <Route path="fav/select" element={<Favourites  cookieFavs={cookieFavs} setCookieFavs={setCookieFavs} setSelectedSinger={setSelectedSinger}  stateVer={stateVer} lang={lang} selectingYesNo={true} tableNo={tableNo}/>} />

                    <Route path="overview" element={<Overview skin={skin} stateNextTable={stateNextTable} stateDuration={stateDuration} statePlaybackSong={statePlaybackSong} statePlaybackYT={statePlaybackYT} stateTables={stateTables} stateVer={stateVer} lang={lang} statePlaylist={statePlaylist} statePlaylistYT={statePlaylistYT} tableNo={tableNo}/>} />

                    <Route path="yt" element={<Yt stateVer={stateVer} lang={lang} selectingYesNo={false} tableNo={tableNo} stateYouTube={stateYouTube}/>} />
                    <Route path="yt/select" element={<Yt stateVer={stateVer} lang={lang} selectingYesNo={true} tableNo={tableNo}  stateYouTube={stateYouTube}/>} />


                </Route>
                <Route path="/" element={<Root setLang={setLang} lang={lang}/>} />
                <Route path="/NoRoomError" element={<NoRoomError setLang={setLang} lang={lang}/>} />
                <Route path="/admin"  >
                    <Route index element={<Admin micEnabled={micEnabled} stateNextSong={stateNextSong} stateNextYtname={stateNextYtname} stateNextTable={stateNextTable} statePlaybackYT={statePlaybackYT} statePlaybackSong={statePlaybackSong}  lang={lang} tableNo={tableNo} stateTables={stateTables} setTableNo={setTableNo} selectingQuota={false} selectingCode={false} selectingMsg={false} selectingInterval={false} selectingClear={false} selectingKey={false} selectingAll={false}/> } />
                    <Route path="quota" element={<Admin micEnabled={micEnabled}  stateNextSong={stateNextSong} stateNextYtname={stateNextYtname} stateNextTable={stateNextTable} statePlaybackYT={statePlaybackYT} statePlaybackSong={statePlaybackSong}  lang={lang} tableNo={tableNo} stateTables={stateTables} setTableNo={setTableNo} selectingQuota={true} selectingCode={false} selectingMsg={false} selectingInterval={false} selectingClear={false} selectingKey={false} selectingAll={false}/> } />
                    <Route path="code" element={<Admin micEnabled={micEnabled}  stateNextSong={stateNextSong} stateNextYtname={stateNextYtname} stateNextTable={stateNextTable} statePlaybackYT={statePlaybackYT} statePlaybackSong={statePlaybackSong}  lang={lang} tableNo={tableNo} stateTables={stateTables} setTableNo={setTableNo} selectingQuota={false} selectingCode={true} selectingMsg={false} selectingInterval={false} selectingClear={false} selectingKey={false} selectingAll={false}/> } />
                    <Route path="msg" element={<Admin  micEnabled={micEnabled} stateNextSong={stateNextSong} stateNextYtname={stateNextYtname} stateNextTable={stateNextTable} statePlaybackYT={statePlaybackYT} statePlaybackSong={statePlaybackSong}  lang={lang} tableNo={tableNo} stateTables={stateTables} setTableNo={setTableNo} selectingQuota={false} selectingCode={false} selectingMsg={true} selectingInterval={false} selectingClear={false} selectingKey={false} selectingAll={false}/> } />
                    <Route path="interval" element={<Admin micEnabled={micEnabled}  stateNextSong={stateNextSong} stateNextYtname={stateNextYtname} stateNextTable={stateNextTable} statePlaybackYT={statePlaybackYT} statePlaybackSong={statePlaybackSong}  lang={lang} tableNo={tableNo} stateTables={stateTables} setTableNo={setTableNo} selectingQuota={false} selectingCode={false} selectingMsg={false} selectingInterval={true} selectingClear={false} selectingKey={false} selectingAll={false}/> } />
                    <Route path="clear" element={<Admin micEnabled={micEnabled}  stateNextSong={stateNextSong} stateNextYtname={stateNextYtname} stateNextTable={stateNextTable} statePlaybackYT={statePlaybackYT} statePlaybackSong={statePlaybackSong}  lang={lang} tableNo={tableNo} stateTables={stateTables} setTableNo={setTableNo} selectingQuota={false} selectingCode={false} selectingMsg={false} selectingInterval={false} selectingClear={true} selectingKey={false} selectingAll={false}/> } />
                    <Route path="key" element={<Admin micEnabled={micEnabled} stateNextSong={stateNextSong} stateNextYtname={stateNextYtname} stateNextTable={stateNextTable} statePlaybackYT={statePlaybackYT} statePlaybackSong={statePlaybackSong}  lang={lang} tableNo={tableNo} stateTables={stateTables} setTableNo={setTableNo} selectingQuota={false} selectingCode={false} selectingMsg={false} selectingInterval={false} selectingClear={false} selectingKey={true} selectingAll={false}/> } />
                    <Route path="all" element={<Admin micEnabled={micEnabled}  stateNextSong={stateNextSong} stateNextYtname={stateNextYtname} stateNextTable={stateNextTable} statePlaybackYT={statePlaybackYT} statePlaybackSong={statePlaybackSong}  lang={lang} tableNo={tableNo} stateTables={stateTables} setTableNo={setTableNo} selectingQuota={false} selectingCode={false} selectingMsg={false} selectingInterval={false} selectingClear={false} selectingKey={false} selectingAll={true}/> } />

                    
                    <Route path="songs" element={<Songs skin={skin} cookieFavs={cookieFavs} setCookieFavs={setCookieFavs} setSelectedSinger={setSelectedSinger} stateVer={stateVer} lang={lang} selectingYesNo={false} tableNo={tableNo} footerDisabled={true}/>} />
                    <Route path="songs/select" element={<Songs skin={skin} cookieFavs={cookieFavs} setCookieFavs={setCookieFavs} setSelectedSinger={setSelectedSinger} stateVer={stateVer} lang={lang} selectingYesNo={true} tableNo={tableNo} footerDisabled={true}/>} />


                    <Route path="artists/singer" element={<Artists  cookieFavs={cookieFavs} setCookieFavs={setCookieFavs} selectedSinger={selectedSinger} setSelectedSinger={setSelectedSinger}  stateVer={stateVer} lang={lang} selectingSinger={true} selectingYesNo={false} tableNo={tableNo} footerDisabled={true}/>} />
                    <Route path="artists/singer/select" element={<Artists cookieFavs={cookieFavs} setCookieFavs={setCookieFavs} selectedSinger={selectedSinger} setSelectedSinger={setSelectedSinger}  stateVer={stateVer} lang={lang} selectingSinger={true} selectingYesNo={true} tableNo={tableNo} footerDisabled={true}/>} />


                </Route>
            </Routes>
        </div>
        </>
    )
}

export { SendMessage, socket };
export default App;